import { render, staticRenderFns } from "./CanvasSeats.vue?vue&type=template&id=35c8a462&scoped=true&"
import script from "./CanvasSeats.vue?vue&type=script&lang=ts&"
export * from "./CanvasSeats.vue?vue&type=script&lang=ts&"
import style0 from "./CanvasSeats.vue?vue&type=style&index=0&id=35c8a462&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c8a462",
  null
  
)

export default component.exports